import { Frame } from '@xing-com/crate-lebenslauf-xinglets';
import type { Xinglet } from '@xing-com/crate-xinglet';

import { Advisory } from './advisory';

export default class TemplatesXinglet implements Xinglet {
  public getComponent() {
    return (): JSX.Element => (
      <Frame>
        <Advisory />
      </Frame>
    );
  }
}
